import React, { memo } from 'react';
import { makeStyles } from 'tss-react/mui';
import { Typography } from '@mui/material';
import { capitalize } from '@mui/material/utils';

import FlagSvg from 'components/svg/flag.svg';

interface IProps {
  text: string;
  large?: boolean;
  color: 'red' | 'orange' | 'default';
}

const useStyles = makeStyles()((theme) => ({
  wrapper: {
    position: 'absolute',
    zIndex: 2,
    left: -58,
    top: 36,
    width: 260,
    height: 70,
    transform: 'rotate(-45deg)',
    textAlign: 'center',
    userSelect: 'none',
  },
  large: {
    left: -68,
    top: 45,
    width: 300,
    height: 70,
  },
  font: {
    color: 'white',
    textTransform: 'uppercase',
    letterSpacing: '0.03em',
    fontWeight: 'bold',
    lineHeight: '46px',
  },
  fontLarge: {
    letterSpacing: '0.03em',
    lineHeight: '54px',
  },
  flag: {
    position: 'absolute',
    zIndex: -1,
    left: 0,
    right: 0,
    bottom: 0,
    top: 0,
  },
  colorOrange: {
    fill: theme.palette.custom.orange.main,
  },
  colorDefault: {
    fill: theme.palette.text.secondary,
  },
  colorRed: {
    fill: theme.palette.secondary.main,
  },
}));

const Flag: React.FC<React.PropsWithChildren<IProps>> = ({ text, color = 'default', large }) => {
  const { classes, cx } = useStyles();
  return (
    <div className={cx(classes.wrapper, { [classes.large]: large })}>
      <FlagSvg className={cx(classes.flag, classes[`color${capitalize(color)}` as keyof typeof classes])} />
      <Typography variant="h6" className={cx(classes.font, { [classes.fontLarge]: large })}>
        {text}
      </Typography>
    </div>
  );
};

export default memo(Flag);
